import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

export class Config{
  dist:string;
  Map:string;
  report:string;
  version:string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  config: Config;

  constructor(private http: HttpClient) { }
  loadConfig() {
    return this.http
      .get<Config>('./assets/config.json')
      .toPromise()
      .then(config => {
        this.config = config;
      });
  }
}
